import React from 'react';
import { Select, Button, chakra as C } from '@tapresearch/ui/components';
import * as S from '../CampaignSurveyResultQuestionItem.styled';
import useAsset from '../../hook/useAsset';
var GraphToggle = C(S.Button);
export function ActionPanel(param) {
    var question = param.question, questions = param.questions, isMultipleChoice = param.isMultipleChoice, isRanking = param.isRanking, isCrossTab = param.isCrossTab, setCrossTabQuestionId = param.setCrossTabQuestionId, crossTabQuestionId = param.crossTabQuestionId, renderMode = param.renderMode, setRenderMode = param.setRenderMode, contributionMode = param.contributionMode, setShowEmptyResults = param.setShowEmptyResults, setContributionMode = param.setContributionMode, showEmptyResults = param.showEmptyResults;
    var asset = useAsset();
    return (isMultipleChoice || isRanking) && /*#__PURE__*/ React.createElement(S.PanelAction, null, /*#__PURE__*/ React.createElement(S.PanelActionLeftContainer, null, /*#__PURE__*/ React.createElement(S.PanelActionIconContainer, null, /*#__PURE__*/ React.createElement("img", {
        src: asset.arrow_right_icon
    })), /*#__PURE__*/ React.createElement(Select, {
        boxShadow: "sm",
        variant: "outline",
        fontWeight: "medium",
        value: crossTabQuestionId,
        onChange: function(e) {
            return setCrossTabQuestionId(e.target.value);
        }
    }, /*#__PURE__*/ React.createElement("option", {
        value: ""
    }, "Choose comparison"), questions.map(function(q) {
        return q.answer_type !== asset.constants.TAP_ANSWER_TYPE_FREE_TEXT && q.answer_type !== asset.constants.TAP_ANSWER_TYPE_MESSAGE && (!isRanking || isRanking && q.answer_type !== asset.constants.TAP_ANSWER_TYPE_RANKING) && q.id !== question.id && /*#__PURE__*/ React.createElement("option", {
            value: q.id,
            key: q.id
        }, q.name);
    }))), /*#__PURE__*/ React.createElement(S.PanelActionRightContainer, null, /*#__PURE__*/ React.createElement(S.LabelContainer, null, /*#__PURE__*/ React.createElement(S.ButtonGroup, null, /*#__PURE__*/ React.createElement(GraphToggle, {
        bg: renderMode === 'graph' ? 'blue.500' : 'gray.300',
        active: renderMode === 'graph',
        onClick: function() {
            return setRenderMode('graph');
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: asset.bar_chart_icon
    })), /*#__PURE__*/ React.createElement(GraphToggle, {
        bg: renderMode === 'table' ? 'blue.500' : 'gray.300',
        active: renderMode === 'table',
        onClick: function() {
            return setRenderMode('table');
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: asset.table_icon
    }))), (isCrossTab || isRanking) && /*#__PURE__*/ React.createElement(S.ButtonGroup, null, /*#__PURE__*/ React.createElement(GraphToggle, {
        bg: contributionMode === 'percentage' ? 'blue.500' : 'gray.300',
        active: contributionMode === 'percentage',
        onClick: function() {
            return setContributionMode('percentage');
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: asset.percentage_icon
    })), /*#__PURE__*/ React.createElement(GraphToggle, {
        bg: contributionMode === 'number' ? 'blue.500' : 'gray.300',
        active: contributionMode === 'number',
        onClick: function() {
            return setContributionMode('number');
        }
    }, /*#__PURE__*/ React.createElement("img", {
        src: asset.hash_tag_icon
    }))), isCrossTab && /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return setShowEmptyResults(!showEmptyResults);
        },
        variant: showEmptyResults ? 'solid' : 'outline',
        colorScheme: "blue",
        size: "sm",
        minW: "120px"
    }, showEmptyResults ? 'Hide Empty' : 'Show Empty'))));
}
